import { Checkbox, Select } from 'antd'
import { OptionProps } from 'antd/lib/select'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { ProductFilter } from './ProductFilter'
import { Supplier } from '@getgreenline/homi-shared'

interface Props {
  productFilter: ProductFilter
  suppliersWithName: Supplier[]
  filterOption: (input: string, option: React.ReactElement<OptionProps>) => boolean
}

export const SupplierSelect = observer(
  ({ productFilter, suppliersWithName, filterOption }: Props) => {
    return (
      <Select<number>
        className='gr-filter-item gr-filter-gutter antd-v3-select-override'
        showSearch
        showArrow
        placeholder={'Brands (none)'}
        menuItemSelectedIcon={<></>}
        value={productFilter.productFilter.selectedSupplierId}
        filterOption={filterOption}
      >
        {suppliersWithName.map((supplier: Supplier) => (
          <Select.Option title={supplier.name} key={supplier.id} value={supplier.id}>
            <Checkbox
              checked={productFilter.productFilter.selectedSupplierId === supplier.id}
              className='w-100'
              onChange={(e) =>
                productFilter.setSelectedSupplierId(e.target.checked ? supplier.id : undefined)
              }
            >
              {supplier.name}
            </Checkbox>
          </Select.Option>
        ))}
      </Select>
    )
  },
)
